export default {
    title: "Sharing of statistics back on track",
    message: "All good! Thanks for logging back in, the stats sharing is back on.",
};
